// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rootNodeWrapper--1qsx-x05 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px 4px;\n}\n\n.alias--1WcxxXYf {\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.downIcon--8iVbVvVo {\n  position: relative;\n  top: 2px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rootNodeWrapper": "rootNodeWrapper--1qsx-x05",
	"alias": "alias--1WcxxXYf",
	"downIcon": "downIcon--8iVbVvVo"
};
export default ___CSS_LOADER_EXPORT___;
